import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class StorageService {

    setLocal(key: string, value: any): void {
        localStorage.setItem(key, JSON.stringify(value));
    }

    getLocal(key: string): any {
        const value = localStorage.getItem(key);
        return value ? JSON.parse(value) : null;
    }

    removeLocal(key: string): void {
        localStorage.removeItem(key);
    }

    clearLocal(): void {
        localStorage.clear();
    }

    setSession(key: string, value: any): void {
        sessionStorage.setItem(key, JSON.stringify(value));
    }

    getSession(key: string): any {
        const value = sessionStorage.getItem(key);
        return value ? JSON.parse(value) : null;
    }

    removeSession(key: string): void {
        sessionStorage.removeItem(key);
    }

    clearSession(): void {
        sessionStorage.clear();
    }

}
